import { useTranslation } from 'react-i18next';

import { Icon } from '../../UI';
import { Confirm } from '../../NewStrategy/Confirm';

import { useStrategiesContext } from '../StrategiesContext';

export const ConfirmAction = ({
  action,
  strategyName,
}: {
  action: 'deleted' | 'duplicated';
  strategyName: string;
}) => {
  const { t } = useTranslation();

  const { closeModal } = useStrategiesContext();

  return (
    <Confirm
      footerNavigatorClassName="my-10"
      saveButtonMane={t('common.continue')}
      subtitle={t('strategies.modal.deleted.description')}
      svg={
        <Icon
          className="w-full ml-1/2 -mt-5 mb-8"
          fill={false}
          svgName="circleCheck"
        />
      }
      title={t(`strategies.modal.${action}.title`, { strategyName })}
      onSave={closeModal}
    />
  );
};
